import { BadgeClass } from '../shared/badge/Badge';

export let AlertLevel = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH',
    NONE: 'NONE'
};

export let AlertLevelClassName = {
    LOW: 'alert-level-low',
    MEDIUM: 'alert-level-medium',
    HIGH: 'alert-level-high',
    NONE: 'alert-level-none'
};

export let AlertLevelFriendlyName = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    NONE: 'None'
};

export function getClassNameForAlertLevel(alertLevel) {
    switch (alertLevel) {
        case AlertLevel.LOW:
            return AlertLevelClassName.LOW;
        case AlertLevel.MEDIUM:
            return AlertLevelClassName.MEDIUM;
        case AlertLevel.HIGH:
            return AlertLevelClassName.HIGH;
        case AlertLevel.NONE:
            return AlertLevelClassName.NONE;
        default:
            return '';
    }
}

export function getFriendlyNameForAlertLevel(alertLevel) {
    switch (alertLevel) {
        case AlertLevel.LOW:
            return AlertLevelFriendlyName.LOW;
        case AlertLevel.MEDIUM:
            return AlertLevelFriendlyName.MEDIUM;
        case AlertLevel.HIGH:
            return AlertLevelFriendlyName.HIGH;
        case AlertLevel.NONE:
            return AlertLevelFriendlyName.NONE;
        default:
            return '';
    }
}

export const getBadgeClassNameFromAlertLevel = type => {
    switch (type) {
        case AlertLevel.LOW:
            return BadgeClass.Low;
        case AlertLevel.MEDIUM:
            return BadgeClass.Medium;
        case AlertLevel.HIGH:
            return BadgeClass.High;
        default:
            return type;
    }
};
